const PublicIcon = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.8335 36.668H37.1668"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 3.33203C23.1667 4.3987 26.1667 4.3987 28.8333 3.33203V8.33203C26.1667 9.3987 23.1667 9.3987 20.5 8.33203V3.33203Z"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 8.33203V13.332"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8332 13.332H12.1665C8.83317 13.332 7.1665 14.9987 7.1665 18.332V36.6654H33.8332V18.332C33.8332 14.9987 32.1665 13.332 28.8332 13.332Z"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.1333 20H32.8666"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8169 20V36.6667"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M20.4834 20V36.6667"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M27.1499 20V36.6667"
      stroke="#6F6F6F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
)
export default PublicIcon
